const classes = Object.freeze({
    paper: 'll-select__paper ll-select__paper_sport',
    list: 'll-select__list'
});

export {
    classes,
};